export const APPS_CONFIG = {
  nipun_mis: {
    title: "Nipun MIS",
    color: "#003B75",
    route: "/nipun-mis",
    navConfig: {
      misDashboard: { name: "Dashboard", path: "" },
      misCot: { name: "COT", path: "/cot" },
      misSopan: { name: "Sopan", path: "/sopan" },
    },
  },
  nipun_report: {
    title: "Nipun Report",
    color: "#003B75",
    route: "/nipun-report",
    navConfig: {
      all: { name: "Dashboard", path: "" },
    },
  },
  chatbot_mis: {
    title: "Chatbot MIS",
    color: "#003B75",
    route: "/chatbot-mis",
    navConfig: {
      misDashboard: { name: "Dashboard", path: "" },
      chatbot_learning_outcomes: {
        name: "Learning Outcomes",
        path: "/chatbot_learning_outcomes",
      },
      chatbot_games: {
        name: "Games",
        path: "/chatbot_games",
      },
      templates: { name: "Templates", path: "/templates" },
      threads: { name: "Threads", path: "/threads" },
    },
  },
  // whatsapp_automation: {
  //   title: "School Analytics",
  //   color: "#003B75",
  //   route: "/whatsapp-automation",
  //   navConfig: {
  //     dashboard: { name: "Dashboard", path: "/dashboard" },
  //   },
  // },
  whatsapp_automation_mis: {
    title: "School Analytics MIS",
    color: "#003B75",
    route: "/whatsapp_automation_mis",
    navConfig: {
      server_status: { name: "Server Status", path: "/server_status" },
      // qr_scan: { name: "QR Scan", path: "/qr_scan" },
      sync_servers: { name: "Sync Servers", path: "/sync_servers" },
      groups: { name: "Groups", path: "/groups" },
      admin_restricted_groups: { name: "Admin Restricted Groups", path: "/admin_restricted_groups" },
      messages: { name: "Messages", path: "/messages" },
      bulk_jobs: { name: "Bulk Jobs", path: "/bulk_jobs" },
      most_active: { name: "Most Active", path: "/most_active" },
      automation_template: { name: "Template", path: "/automation_template" },
      automation_media: { name: "Media", path: "/automation_media" },
      // engagement_report: {
      //   name: "Engagement report",
      //   path: "/engagement_report",
      // },
    },
  },
  orf_report: {
    title: "ORF Report",
    color: "#003B75",
    route: "/orf",
    navConfig: {
      dashboard: { name: "Dashboard", path: "/dashboard" },
      raw_data: { name: "Raw Data", path: "/raw_data" },
      version_data: { name: "Version Data", path: "/version_data" },
    },
  },
  orf_mis: {
    title: "ORF MIS",
    color: "#003B75",
    route: "/orf-mis",
    navConfig: {
      dashboard: { name: "Dashboard", path: "/dashboard" },
      user_register: { name: "User Register", path: "/user_register" },
      templates: { name: "Templates", path: "/templates" },
    },
  },
  prakashak_report: {
    title: "PRAKASHAK Report",
    color: "#003B75",
    route: "/prakashak/dashboard",
    navConfig: {
      dashboard: { name: "Dashboard", path: "/prakashakDashboard" },
    },
  },
  binadidi_chatbot: {
    title: "Bina Didi Chatbot",
    color: "#ce6e00ff",
    route: "/chatbot",
    navConfig: {
      dashboard: { name: "Dashboard", path: "/prakashakDashboard" },
    },
  },
};
